import { closeIcon } from 'assets/icons';
import { IconButton } from 'components';

import * as S from './ChangesModalHeader.styled';

const ChangesModalHeader = ({ title, isOpen$ }) => {
  const closeModal = () => {
    isOpen$.value = false;
  };

  return (
    <S.Header>
      <S.HeaderTitle>{title}</S.HeaderTitle>
      <IconButton.SmallSizeBigIcon
        icon={closeIcon}
        type={IconButton.btnTypes.tertiary}
        onClick={closeModal}
      />
    </S.Header>
  );
};

export default ChangesModalHeader;
